import Phaser from 'phaser';
import { hasUrlFlag } from '../game/gameConfig';
import { sceneAfter } from '../game/scenes';
import { addCoverImage, setImageHeight } from '../game/sceneArt';
import { createIconHud } from '../ui/IconHud';
import { SynthSfx } from '../audio/SynthSfx';

export class LaunchScene extends Phaser.Scene {
  private rocket!: Phaser.GameObjects.Image;
  private countdown!: Phaser.GameObjects.Text;
  private label!: Phaser.GameObjects.Text;
  private rocketKey = 'rocket_launch';

  constructor() {
    super('Launch');
  }

  preload() {
    this.load.image('earth_bg', 'assets/earthbg.png');
    this.load.image('rocket_launch', 'assets/rocket-pad-v3.png');
  }

  create() {
    createIconHud(this);
    const freeze = hasUrlFlag('freeze');
    const { width, height } = this.scale;
    const padY = height - 36;

    addCoverImage(this, 'earth_bg', -20);
    this.add.rectangle(width / 2, height - 22, width, 92, 0x222938, 0.92);
    this.add.rectangle(width / 2, padY - 20, width, 10, 0x8f98aa, 0.95);
    this.add.circle(width * 0.5, padY - 18, 96, 0xffb36a, 0.08).setDepth(2);

    this.rocket = setImageHeight(this.add.image(width / 2, padY - 190, this.rocketKey), 324).setDepth(10);

    this.countdown = this.add.text(width / 2, 108, '3', {
      fontFamily: 'monospace',
      fontSize: '84px',
      color: '#fff3d2',
    }).setOrigin(0.5);

    this.label = this.add.text(width / 2, 176, 'Cuenta regresiva para despegar', {
      fontFamily: 'monospace',
      fontSize: '20px',
      color: '#d8e8ff',
    }).setOrigin(0.5);

    if (freeze) {
      this.countdown.setText('3');
      this.label.setText('Vista previa del despegue');
      return;
    }

    ['3', '2', '1', 'DESPEGUE'].forEach((value, index) => {
      this.time.delayedCall(index * 900, () => {
        this.countdown.setText(value);
        this.countdown.setScale(1.22);
        this.tweens.add({
          targets: this.countdown,
          scale: 1,
          duration: 220,
          ease: 'Back.Out',
        });
      });
    });

    this.time.delayedCall(3000, () => {
      this.launchRocket();
    });
  }

  private launchRocket() {
    const motorLoop = this.time.addEvent({
      delay: 300,
      loop: true,
      callback: () => {
        SynthSfx.motor();
      },
    });

    // Multi-layered flame effect
    const flameOuter = this.add.ellipse(this.rocket.x, 0, 64, 90, 0xff4400, 0.7).setDepth(9);
    const flameMiddle = this.add.ellipse(this.rocket.x, 0, 40, 70, 0xff8800, 0.8).setDepth(9);
    const flameInner = this.add.ellipse(this.rocket.x, 0, 22, 50, 0xffdd44, 0.9).setDepth(9);
    const flameGlow = this.add.circle(this.rocket.x, 0, 52, 0xff6600, 0.15).setDepth(8);
    const flames = [flameOuter, flameMiddle, flameInner, flameGlow];

    const flameLoop = this.time.addEvent({
      delay: 50,
      loop: true,
      callback: () => {
        const baseY = this.rocket.y + this.rocket.displayHeight * 0.48;
        flameOuter.setPosition(this.rocket.x + Phaser.Math.Between(-3, 3), baseY + Phaser.Math.Between(0, 8));
        flameOuter.setSize(Phaser.Math.Between(54, 72), Phaser.Math.Between(80, 110));
        flameMiddle.setPosition(this.rocket.x + Phaser.Math.Between(-2, 2), baseY + Phaser.Math.Between(-2, 4));
        flameMiddle.setSize(Phaser.Math.Between(32, 48), Phaser.Math.Between(60, 85));
        flameInner.setPosition(this.rocket.x, baseY + Phaser.Math.Between(-4, 2));
        flameInner.setSize(Phaser.Math.Between(16, 28), Phaser.Math.Between(40, 60));
        flameGlow.setPosition(this.rocket.x, baseY);
        flameGlow.setRadius(Phaser.Math.Between(44, 62));
        flameGlow.setAlpha(Phaser.Math.FloatBetween(0.1, 0.22));
      },
    });

    this.label.setText('El cohete despega rumbo a la Luna');
    this.cameras.main.shake(1400, 0.0032);

    this.tweens.add({
      targets: this.rocket,
      y: -260,
      duration: 2500,
      ease: 'Sine.easeIn',
      onComplete: () => {
        flameLoop.destroy();
        motorLoop.destroy();
        flames.forEach((f) => f.destroy());
        const next = sceneAfter('Launch');
        if (next) {
          this.scene.start(next);
        }
      },
    });
  }
}
